import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { DocumentRequestService } from 'src/app/v2-node-api/services/document-request.service';

@Component({
  selector: 'send-message',
  templateUrl: './send-message.component.html',
  styleUrls: ['./send-message.component.scss']
})
export class SendMessageComponent implements OnInit {


  public message="";
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<SendMessageComponent>,
  private formBuilder: FormBuilder,
  private dialog: MatDialog,
  protected documentRequestService: DocumentRequestService) { }

  ngOnInit(): void {
  }

  close(){
    this.dialogRef.close();
  }
 onInvalidate(){
   this.documentRequestService.sendMessage(this.data.oldRequest._id,this.message).subscribe((res)=>{
      this.dialogRef.close();
    });

    this.close();
  }

  
}
